import React from 'react';
import { FormattedMessage } from 'react-intl';
import * as UI from '../../../ui';
import { useFelaEnhanced } from '@ackee/fela';
import * as felaRules from './DeIntroColumn.rules';

import { MessageKey } from 'modules/intl';

const { Title, TitleTypes, Text } = UI;

interface DeIntroColumnProps {
    title: string;
    description: string;
    isLast: boolean;
}

const DeIntroColumn = ({ title, description, isLast }: DeIntroColumnProps) => {
    const { styles, rules } = useFelaEnhanced(felaRules);

    return (
        <div className={styles.container}>
            {/* @ts-expect-error */}
            <Title extend={{ title: rules.extendTitle }} as={TitleTypes.H3} type={TitleTypes.H4}>
                <FormattedMessage id={title as MessageKey} />
            </Title>
            {/* @ts-expect-error */}
            <Text extend={{ text: rules.extendText }} as="p">
                <FormattedMessage id={description as MessageKey} />
            </Text>
            {!isLast && <div className={styles.divider} />}
        </div>
    );
};

export default DeIntroColumn;
